import request from '@/utils/request';

// 查询员工列表
export function getEmployeeListApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/employee/getListByPage',
    method: 'post',
    data
  });
}
// 删除员工
export function deleteEmployeeApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/webEmployee/remove',
    method: 'post',
    data
  });
}
// 角色列表查询
export function getRoleListApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/roles/getRoleList',
    method: 'post',
    data
  });
}
// 导出导入员工失败的数据
export function exportFailDataApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/webEmployee/exportErrorMsgFile',
    method: 'post',
    responseType: 'blob',
    data
  })
}
// 员工角色切换
export function setEmployeeRoleApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/employee/modify',
    method: 'post',
    data
  });
}
// 添加员工
export function addEmployeeApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/webEmployee/add',
    method: 'post',
    data
  });
}
// 添加角色
export function addUserRoleApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/roles/addOrModifyRole',
    method: 'post',
    data
  });
}
// 获取专属客服群数据
export function getExclusiveGroupApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/ydBatchOpt/searchUserCustomTeams',
    method: 'post',
    data
  });
}
// 批量拉人进专属客服群
export function joinExclusiveGroupApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/ydBatchOpt/addTeamMembersOfCustom',
    method: 'post',
    data
  });
}
// 组织内员工隔离状态
export function setEmployeeIsClosedApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/webGroups/setEmployeeIsClosed',
    method: 'post',
    data
  });
}
// 设置员工备注
export function setUserNickNameApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/employee/setUserNickName',
    method: 'post',
    data
  })
}
// 批量删除员工
export function mulRemoveApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/webEmployee/batchRemove',
    method: 'post',
    data
  })
}
